import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { MapPin } from "lucide-react";

const POPULAR = ["Dapoli", "Ratnagiri", "Ganpatipule", "Tarkarli", "Alibaug", "Murud", "Harihareshwar", "Guhagar", "Malvan"];

export const HeroSearch = () => {
  const [q, setQ] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  const doSearch = (e) => {
    e.preventDefault();
    if (q.trim()) nav(`/search/homestays-in-${q.trim().toLowerCase().replace(/\s+/g, "-")}`);
  };

  const onChange = (e) => {
    const v = e.target.value;
    setQ(v);
    const f = v.trim() ? POPULAR.filter(l => l.toLowerCase().includes(v.toLowerCase())) : POPULAR;
    setSuggestions(f);
    setOpen(f.length > 0);
  };

  const pick = (loc) => { setQ(loc); setOpen(false); nav(`/search/homestays-in-${loc.toLowerCase()}`); };

  return (
    <section className="relative -mt-7 z-20 px-4" data-testid="search-section">
      <div className="relative w-full max-w-2xl mx-auto" data-testid="search-box">
        <form onSubmit={doSearch} className="relative flex items-center bg-white rounded-full shadow-floating border border-border/30">
          <MapPin className="absolute left-6 w-5 h-5 text-muted-foreground" />
          <Input
            type="text" placeholder="Search by location or homestay name" value={q}
            onChange={onChange}
            onFocus={() => { setSuggestions(q ? POPULAR.filter(l => l.toLowerCase().includes(q.toLowerCase())) : POPULAR); setOpen(true); }}
            onBlur={() => setTimeout(() => setOpen(false), 200)}
            className="flex-1 pl-14 pr-4 py-6 text-base rounded-full border-0 focus-visible:ring-0 bg-transparent"
            data-testid="search-input"
          />
          <Button type="submit" className="absolute right-2 bg-primary text-white hover:bg-primary/90 rounded-full px-7 py-5 text-sm font-semibold" data-testid="search-button">
            Search
          </Button>
        </form>
        {open && suggestions.length > 0 && (
          <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-lg border z-50 overflow-hidden">
            <div className="p-2">
              <p className="px-3 py-1.5 text-xs text-muted-foreground font-medium">Popular Destinations</p>
              {suggestions.map(loc => (
                <button key={loc} onClick={() => pick(loc)} className="w-full flex items-center gap-3 px-3 py-2 hover:bg-muted rounded-lg text-left text-sm">
                  <MapPin className="w-4 h-4 text-primary" /><span>{loc}</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
